angular.module('menuLeadingColor', [
  'ihestia-menu-templates-app'
]);